export const INTERNAL_DEPARTMENTS = ["boedo"] as const;

export const isInternalDepartment = (departamento?: string | number | null): boolean =>
  INTERNAL_DEPARTMENTS.includes(
    (departamento ?? "").toString().trim().toLowerCase() as (typeof INTERNAL_DEPARTMENTS)[number]
  );
